import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
} from "@angular/core";
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";

let nextTextareaId = 0;

@Component({
  selector: "app-cmn-textarea",
  templateUrl: "./cmn-textarea.component.html",
  styleUrls: ["./cmn-textarea.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CmnTextareaComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmnTextareaComponent implements ControlValueAccessor {
  private readonly generatedId = `cmn-textarea-${nextTextareaId++}`;

  private onTouched: () => void = () => {};
  private onChange: (value: string) => void = () => {};

  @Input() textareaId = "";
  @Input() name = "";
  @Input() label = "";
  @Input() placeholder = "";
  @Input() rows: string | number = 3;
  @Input() maxlength: string | number | null = null;
  @Input({ transform: booleanAttribute }) showCharacterCount = false;

  value = "";
  disabled = false;

  get id(): string {
    return this.textareaId || this.generatedId;
  }

  get characterCount(): number {
    return this.value?.length || 0;
  }

  writeValue(value: string | null): void {
    this.value = value ?? "";
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  handleInput(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;

    this.value = textarea.value;
    this.onChange(this.value);
  }

  handleBlur(): void {
    this.onTouched();
  }
}